import config from "src/config";
import { ResponseDto } from "src/dtos/common/responseDto";
import { EqmInspectSpecPopupDto } from "src/dtos/eqmInspectSpec/eqmInspectSpecPopupDto";
import { getData } from "src/utils/axios/serverHelper";



const baseUrl = `${config.apiUrl}/Inspect`;

export const getInspectPopupList = async (searchText: string, inspectMethod: string, inspectNm: string, inspectType: string, eqmType?: string) => {
	return await getData<ResponseDto<EqmInspectSpecPopupDto[]>>(`${baseUrl}/modal`, {
		params: { searchText, inspectMethod, inspectNm, inspectType, eqmType }
	});
};
